
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/twilio",
      function () {
        return require("private-next-pages/destinations/twilio.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/twilio"])
      });
    }
  